import { Navigate, Route, Routes } from 'react-router-dom';

import { StageGridTab } from 'modules/championship/domain/enums/stage-grid-tab';
import { StageType } from 'modules/championship/domain/enums/stage-type';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { Pages } from 'modules/navigation/domain/enums/pages';
import StageGrid from './stage-grid';
import StageMatrix from './stage-matrix/stage-matrix';
import StageStanding from './stage-standing/stage-standing';
import StageStandingTabs from './stage-standing-tabs';

/** Только у круговых этапов «Сетка матчей» распадается на «Таблицу» и «Шахматку». */
const STANDING_STAGE_TYPES: StageType[] = [StageType.ROUND_ROBIN_1, StageType.ROUND_ROBIN_2];

type StageGridRoutesProps = {
  stage: StageV2;
};

/**
 * Подвкладка «Сетка матчей»: `/steps/:stageId/grid`.
 *
 * Тип этапа решает, есть ли под-сегмент. У групповых этапов и плей-офф конечный
 * адрес — сам `/grid`, поэтому лишних веток в карте адресов не появляется.
 */
const StageGridRoutes = ({ stage }: StageGridRoutesProps) => {
  if (!STANDING_STAGE_TYPES.includes(stage.type)) {
    return <StageGrid stage={stage} />;
  }

  const standingRoute = Pages.CHAMPIONSHIPS.STEPS.builders.grid(stage.championshipId, stage.id, StageGridTab.STANDING);

  return (
    <Routes>
      <Route element={<StageStandingTabs stage={stage} />}>
        <Route index element={<Navigate to={standingRoute} replace />} />
        <Route path={StageGridTab.STANDING} element={<StageStanding stage={stage} />} />
        <Route path={StageGridTab.MATRIX} element={<StageMatrix stage={stage} />} />
      </Route>
      <Route path="*" element={<Navigate to={standingRoute} replace />} />
    </Routes>
  );
};

export default StageGridRoutes;
